/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  order.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { axiosAPIUrl, Parameter } from './index'

export class PayStatusDTO {
	// 订单编号
	orderId?: string
	// 订单金额
	orderMoney
	// 已付款金额
	playMoney
	// 订单状态描述
	orderStatusDesc
	// 付款状态
	payStatus
	// payWay
	payWay
}

export function payStoreOrderAllin(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/OM/payStoreOrderAllin',
		method: 'post',
		data: parameter,
	})
}
/**
 * 1.20 主动获取支付结果(getPayStatus)
 * @param orderId 订单编号
 */
export function getPayStatus(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<PayStatusDTO>>({
		url: '/StoreOrder/OM/getPayStatus',
		method: 'get',
		params: parameter,
    // extraParams: {showLoading: false}
	})
}

/**
 * 切换汇付支付后的查询接口调整
 * @param orderId 订单编号
 */
export function getPayStatusHuiFu(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<PayStatusDTO>>({
    url: '/paymentService/hf/getPayStatus',
    method: 'get',
    params: parameter,
    // extraParams: {showLoading: false}
  })
}

/**
 * @description 1.13 合作方是否有第三方支付权限(getPayAuthority)
 * @param partnerCompanyId 合作方公司Id
 * @param storeId 店铺编号
 */
export function getPayAuthority(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<PayStatusDTO>>({
		url: '/paymentService/CM/getPayAuthority',
		method: 'get',
		params: parameter,
    // extraParams: {showLoading: false}
	})
}

/**
 * @description 汇付天下支付接口调用路径（支付宝）
 * @param orderId string 订单编号
 * @param payWay string 支付方式(微信Wechat支付宝Alipay)
 * @param payMoney string 付款金额
 * @param type Integer 支付方式(0正常支付，1候补支付)
 */
export function payStoreOrderHuifuAlipay(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/paymentService/hf/payStoreOrderHuifu',
    method: 'post',
    data: parameter,
    // extraParams: {showLoading: false}
  })
}

/**
 * 汇付天下支付接口调用路径（微信）
 * @param orderId string 订单编号
 * @param payWay string 支付方式(微信Wechat支付宝Alipay)
 * @param payMoney string 付款金额
 * @param type Integer 支付方式(0正常支付，1候补支付)
 */
export function payStoreOrderHuifuWeChat(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/paymentService/hf/weChat',
    method: 'post',
    data: parameter,
    // extraParams: {showLoading: false}
  })
}
